import { render, staticRenderFns } from "./AxumSidebar.vue?vue&type=template&id=1b3210e7&scoped=true&"
import script from "./AxumSidebar.vue?vue&type=script&lang=js&"
export * from "./AxumSidebar.vue?vue&type=script&lang=js&"
import style0 from "./AxumSidebar.vue?vue&type=style&index=0&id=1b3210e7&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b3210e7",
  null
  
)

export default component.exports